function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5181 8.69333L12.0165 11.1912L11.1911 12.0166L8.69327 9.51817C7.76387 10.2632 6.60785 10.6684 5.41669 10.6667C2.51869 10.6667 0.166687 8.31475 0.166687 5.41675C0.166687 2.51875 2.51869 0.166748 5.41669 0.166748C8.31469 0.166748 10.6667 2.51875 10.6667 5.41675C10.6684 6.60792 10.2632 7.76393 9.5181 8.69333ZM8.34794 8.2605C9.08825 7.49918 9.50169 6.47867 9.50002 5.41675C9.50002 3.16041 7.67244 1.33341 5.41669 1.33341C3.16035 1.33341 1.33335 3.16041 1.33335 5.41675C1.33335 7.6725 3.16035 9.50008 5.41669 9.50008C6.4786 9.50175 7.49912 9.08831 8.26044 8.348L8.34794 8.2605Z",
  fill: "black"
});

const SvgSearchIcon = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/searchIcon.22acd28c.svg";
export { ForwardRef as ReactComponent };